<template>
	<router-link :to="link" class="w-full md:w-1/4 mt-10">
		<div
			class="searchResult hover:shadow transform hover:scale-105 transition transition-transform duration-200 ease-in-out px-3 rounded py-5"
		>
			<div class="w-32 mx-auto h-32 rounded-full">
				<img
					:src="image"
					alt=""
					class="h-full rounded-full w-full object-cover"
				/>
			</div>
			<h1 class="text-center text-xl text-gray-300 mt-3">
				{{ title }}
			</h1>
		</div>
	</router-link>
</template>

<script>
export default {
	name: 'SearchResult',
	props: {
		title: String,
		image: String,
		link: String
	}
};
</script>
